import Api from '../api';

const resource = '/currency';

export default {
  get(code: string) {
    return Api.post(`${resource}`, {
      code,
    });
  },
};
